<template>
	<div class="judge-gallery alignwide">
		<div class="category-navigation">
			<span class="category-navigation-label">Show me</span>

			<!-- Search -->
			<div class="input-group search-group">
				<input class="form-control" type="text" v-model="searchText" @keyup.enter="doSearch">
				<button @click="doSearch" class="btn btn-primary" type="button">Search</button>
			</div>
			
			<!-- Category Navigation -->
			<category-navigation class="mt-2 mt-lg-0" @change="onCategoryChange"></category-navigation>

			<!-- Review Navigation -->
			<review-navigation class="mt-2 mt-lg-0" @change="onReviewChange"></review-navigation>
		</div>

		<!-- Artwork Grid -->
		<artwork-grid :category="category" :reviewState="reviewState" :showReviews="true" :search="searchResult"></artwork-grid>

		<!-- Reviews -->
		<artwork-review-modal v-if="artworkId" :artworkId="artworkId"></artwork-review-modal>
	</div>
</template>

<script>
import CategoryNavigation from './CategoryNavigation.vue'
import ReviewNavigation from './ReviewNavigation.vue'
import ArtworkGrid from './ArtworkGrid.vue'
import ArtworkReviewModal from './ArtworkReviewModal.vue'

export default {
	props: {
		artworkId: {
			type: Number,
			default: 0
		}
	},

	components: {
		CategoryNavigation,
		ArtworkGrid,
		ReviewNavigation,
		ArtworkReviewModal
	},

	data() {
		return {
			category: '',
			searchText: '',
			searchResult: '',
			reviewState: '',
		}
	},

	computed: {
		isReviewTaskActive() {
			return this.$store.getters.isReviewTaskActive;
		},

		currentArtwork() {
			return this.$store.getters.getCurrentArtwork;
		}
	},

	methods: {
		doSearch() {
			this.searchResult = this.searchText
		},
		onCategoryChange(categoryId) {
			this.category = String(categoryId);
			this.doSearch();
		},

		onReviewChange(reviewState) {
			this.reviewState = String(reviewState);
			this.doSearch();
		}
	}
}
</script>